import type { Card, CardClass, Server, ServerType } from "./types";
import { v3ImagePathFor } from "./v3Images";

const CSV_URL = `${import.meta.env.BASE_URL}data/servers.csv`;

function imagePathFor(id: number): string {
  return `${import.meta.env.BASE_URL}images/servers/${String(id).padStart(2, "0")}.png`;
}

export async function loadServers(): Promise<Server[]> {
  const res = await fetch(CSV_URL);
  if (!res.ok) {
    throw new Error(`Failed to load servers.csv (${res.status})`);
  }
  const text = await res.text();
  return parseServersCsv(text);
}

export function parseServersCsv(text: string): Server[] {
  const lines = text.split(/\r?\n/).filter((l) => l.trim().length > 0);
  if (lines.length === 0) return [];
  const [, ...rows] = lines;
  return rows.map((line) => {
    const [idStr, typeStr, levelStr, name, cardsField] = line.split(",");
    const id = Number(idStr);
    const type = Number(typeStr) as ServerType;
    const level = Number(levelStr);
    const cards: Card[] = cardsField.split(";").map((entry) => {
      const colonIdx = entry.lastIndexOf(":");
      if (colonIdx === -1) return { name: entry, class: "S" as CardClass };
      const name = entry.slice(0, colonIdx);
      const cls = entry.slice(colonIdx + 1) as CardClass;
      return { name, class: cls };
    });
    return {
      id,
      type,
      level,
      name,
      cards,
      imagePath: imagePathFor(id),
      v3ImagePath: v3ImagePathFor(id),
    };
  });
}
